<!--  -->
<template>
    <div class='wrapper box  box_v'>
        <page-head title="新增记录" :btn-list="btnList" @handleBtn="handleBtn" :show-back="true">
        </page-head>
        <Card class="card-wrapper1">
            <Form :label-width="80">
                <row :gutter="40">
                    <i-col span="6">
                        <FormItem label="预约轮次" prop="userName">
                            <Select v-model="roundNO" clearable>
                                <Option v-for="item in roundlist" :value="item.id" 
                                :label="item.label" :key="item.id" :disabled="item.disabled"
                                @click.native="selectRound(item)" @on-clear="selectRound()">
                                    <span>{{item.label}}</span>
                                    <span style="float:right;color:#ccc">{{item.statusName}}</span>
                                </Option>
                            </Select>
                        </FormItem>
                    </i-col>
                </row>
                <row :gutter="40">
                    <i-col span="6">
                        <FormItem label="姓名" prop="userName">
                            <Input v-model="userName" placeholder="请输入姓名" clearable :disabled="disabledInput"/>
                        </FormItem>
                    </i-col>
                    <i-col span="6">
                        <FormItem label="身份证号" prop="idCardNO">
                            <Input v-model="idCardNO" placeholder="请输入身份证号" clearable :disabled="disabledInput"/>
                        </FormItem>
                    </i-col>
                    <i-col span="6" v-if="!disabledInput">
                        <Button class="bkcc-btn" @click="searchPeople">查询</Button>
                    </i-col>
                     <i-col span="6" v-else>
                        <Button class="bkcc-btn" @click="clearSearchPeople">重新选择</Button>
                    </i-col>
                </row>
                <row :gutter="40" v-if="showAll">
                    <i-col span="6">
                        <FormItem label="联系电话" prop="phoneNO">
                            <Input v-model="phoneNO" placeholder="请输入居住地址" clearable />
                        </FormItem>
                    </i-col>
                    <i-col span="6">
                        <FormItem label="居住地址" prop="address">
                            <Input v-model="address" placeholder="请输入居住地址" clearable/>
                        </FormItem>
                    </i-col>
                    <i-col span="6">
                        <FormItem label="预约药店" prop="companyId">
                            <Select v-model="companyId" clearable>
                                <Option v-for="item in qyList" :value="item.companyId" :label="item.companyName" :key="item.companyId"
                                :disabled="item.stockNum==0" @click.native="selectQy(item)" @on-clear="selectQy()">
                                    <span>{{item.companyName}}</span>
                                    <span style="float:right;color:#ccc">{{item.stockNum?'剩余'+item.stockNum:'已约满'}}</span>
                                </Option>
                            </Select>
                        </FormItem>
                    </i-col>
                </row>
            </Form>
        </Card>
    </div>
    
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import pageHead from '../../../components/head'
export default {
    name: 'addRecord',
    //import引入的组件需要注入到对象中才能使用
    components: {pageHead},
    data() {
    //这里存放数据
        return {
            btnList: [{
                name: '提交',
                type: 'submit',
                loading: false,
            }],
            /**提交所需信息 */
            id:-1,
            unionId:"",
            companyId: "",
            roundNO: "",
            userName: "",
            idCardNO: "",
            phoneNO: "",
            address: "",
            roundlist:[],
            showAll:false,
            disabledInput:false
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        handleBtn(type){
            if(type == "submit") this.submit()
        },
        getStatus(st,et,num){
            let now = new Date().getTime()

            st = st.substring(0,19);    
            st = st.replace(/-/g,'/');
            let start_time = new Date(st).getTime()

            et = et.substring(0,19);    
            et = et.replace(/-/g,'/');
            let end_time = new Date(et).getTime()
            if(now<start_time){
                return {
                    status:0,
                    statusName:'未开始'
                }
            }else if (now>=start_time && now<=end_time){
                return {
                    status:num==0?2:1,
                    statusName:num==0?'已约满':'可预约'
                }
            }else{
                return {
                    status:3,
                    statusName:'已结束'
                }
            }
        },
        getRound(){
            this.$get(this.urlobj.getRound,{
                isValid:0
            }).then(res=>{
               
                this.roundlist = res.rows.map(item=>{
                    return{
                        id:item.id,
                        roundNO:item.roundNO,
                        label:'第'+this.$util.number2Chinese(item.roundNO)+'轮',
                        status:this.getStatus(item.beginTime,item.endTime,item.stockNum).status,
                        statusName:this.getStatus(item.beginTime,item.endTime,item.stockNum).statusName,
                        disabled:this.getStatus(item.beginTime,item.endTime,item.stockNum).status == 1 ?false:true,
                        companyList:item.companyList
                    }
                })
                console.log(this.roundlist)
            }).catch(e=>{

            })
        },
        selectRound(item){
            if(item){
                this.roundNO = item.roundNO
                this.qyList = item.companyList
                this.companyId = ""
                this.companyName = ""
                console.log(this.qyList)
            }else{
                this.roundNO = ''
                this.qyList = ''
                this.companyId = ""
                this.companyName = ""
            }
            
        },
        searchPeople(){
            //412326199210185410 //17627797120
            this.$get(this.urlobj.searchPeopleInfo,{
                idCardNO:this.idCardNO,
                userName:this.userName,
            }).then(res=>{
                this.showAll = true
                if(res.rows.length){
                    this.unionId = res.rows[0].unionId
                    this.address = res.rows[0].address
                    this.phoneNO = res.rows[0].phone
                    this.disabledInput = true
                }else{
                    this.$Message.info('未查到该居民信息')
                }
            }).catch(e=>{
                
            })
        },
        clearSearchPeople(){
            this.disabledInput = false;
            this.companyId=""
            this.phoneNO= ""
            this.address=""
            this.showAll = false
        },
        selectQy(item){
            if(item){
                this.companyId = item.companyId;
                this.companyName = item.companyName;
            }else{
                this.companyId = "";
                this.companyName = "";
            }
            
        },
        submit(){
            let data = {
                id:this.id,
                unionId:this.unionId,
                companyId: this.companyId,
                roundNO: this.roundNO,
                userName: this.userName,
                idCardNO: this.idCardNO,
                phoneNO: this.phoneNO,
                address: this.address,
            }
           
            this.btnList[0].loading = true
            this.$post(this.urlobj.addYuyueRecord,data).then(res=>{
                this.$Message.success('提交成功')
                this.btnList[0].loading = false
                this.$router.go(-1)
            }).catch(e=>{
                this.btnList[0].loading = false
            })
        },
        statusChange(val){
        
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getRound()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper{
    height: 100%
  }
  .card-wrapper1 {
    height: 100%;
    margin: 0 20px 20px 20px;
    padding:20px 0;
  }
  /deep/ .ivu-card-body {
    padding-top: 0;
    padding-right: 0;
  }
  /deep/ .ivu-date-picker {
    display: block;
  }
  /deep/ .ivu-time-picker {
    display: block;
  }
  /deep/ .ivu-input-number {
    display: block;
    width: 100%;
  }
</style>